import { createFileRoute, redirect } from '@tanstack/react-router';

// /sales opens its first tab (merchant screens §2 Redirects).
export const Route = createFileRoute('/sales/')({
  beforeLoad: () => {
    throw redirect({ to: '/sales/opportunities' });
  },
});
